"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STATUSES = void 0;

var _ = require(".");

var STATUSES = {
  GOOD: 'GOOD',
  LOW: 'LOW',
  MISSING: 'MISSING',
  IMPROPERLY_INSERTED: 'IMPROPERLY_INSERTED',
  UNKNOWN: 'UNKNOWN',
  NEEDS_REPLACEMENT: 'NEEDS_REPLACEMENT',
  NEEDS_PRIMING: 'NEEDS_PRIMING'
};
exports.STATUSES = STATUSES;

var InventoryType =
/** @class */
function () {
  function InventoryType() {
    this.id = null;
    this.name = null;
    this.zIndex = null;
    this.isActive = null;
    this.testCountPerUnit = null;
    this.unit = null;
    this.pluralUnit = null;
    this.imageUrl = null;
    this.isCartridge = null;
    this.isRequiredCartridge = null;
    this.testTypes = null;
    this.status = STATUSES.UNKNOWN;
    this.cartridgePosition = null;
    this.cartridgeRow = null;
    this.shelfLifeDays = null;
    this.defaultOrderTriggerNumber = null;
    this.defaultOrderQuantity = null;
    this.minimumOrderTriggerNumber = null;
    this.displayToUser = null;
    this.isTestKit = null;
    this.colorHex = null;
    this.practiceInventoryTypes = null;
    this.inUnitLifeDays = null;
  }

  InventoryType.thaw = function (inventoryTypeObj) {
    var _a;

    if (inventoryTypeObj == null) return null;
    var inventoryType = new InventoryType();

    if (inventoryTypeObj.id != null) {
      inventoryType.setId(inventoryTypeObj.id);
    }

    if (inventoryTypeObj.name != null) {
      inventoryType.setName(inventoryTypeObj.name);
    }

    if (inventoryTypeObj.zIndex != null) {
      inventoryType.setZIndex(inventoryTypeObj.zIndex);
    }

    if (inventoryTypeObj.isActive != null) {
      inventoryType.setIsActive(inventoryTypeObj.isActive);
    }

    if (inventoryTypeObj.testCountPerUnit != null) {
      inventoryType.setTestCountPerUnit(inventoryTypeObj.testCountPerUnit);
    }

    if (inventoryTypeObj.unit != null) {
      inventoryType.setUnit(inventoryTypeObj.unit);
    }

    if (inventoryTypeObj.pluralUnit != null) {
      inventoryType.setPluralUnit(inventoryTypeObj.pluralUnit);
    }

    if (inventoryTypeObj.imageUrl != null) {
      inventoryType.setImageUrl(inventoryTypeObj.imageUrl);
    }

    if (inventoryTypeObj.isCartridge != null) {
      inventoryType.setIsCartridge(inventoryTypeObj.isCartridge);
    }

    if (inventoryTypeObj.isRequiredCartridge != null) {
      inventoryType.setIsRequiredCartridge(inventoryTypeObj.isRequiredCartridge);
    }

    if (inventoryTypeObj.testTypes != null) {
      inventoryType.setTestTypes(_.TestType.thawList(inventoryTypeObj.testTypes));
    }

    inventoryType.setStatus((_a = inventoryTypeObj.status) !== null && _a !== void 0 ? _a : STATUSES.UNKNOWN);

    if (inventoryTypeObj.cartridgePosition != null) {
      inventoryType.setCartridgePosition(inventoryTypeObj.cartridgePosition);
    }

    if (inventoryTypeObj.cartridgeRow != null) {
      inventoryType.setCartridgeRow(inventoryTypeObj.cartridgeRow);
    }

    if (inventoryTypeObj.shelfLifeDays != null) {
      inventoryType.setShelfLifeDays(inventoryTypeObj.shelfLifeDays);
    }

    if (inventoryTypeObj.defaultOrderTriggerNumber != null) {
      inventoryType.setDefaultOrderTriggerNumber(inventoryTypeObj.defaultOrderTriggerNumber);
    }

    if (inventoryTypeObj.defaultOrderQuantity != null) {
      inventoryType.setDefaultOrderQuantity(inventoryTypeObj.defaultOrderQuantity);
    }

    if (inventoryTypeObj.minimumOrderTriggerNumber != null) {
      inventoryType.setMinimumOrderTriggerNumber(inventoryTypeObj.minimumOrderTriggerNumber);
    }

    if (inventoryTypeObj.displayToUser != null) {
      inventoryType.setDisplayToUser(inventoryTypeObj.displayToUser);
    }

    if (inventoryTypeObj.isTestKit != null) {
      inventoryType.setIsTestKit(inventoryTypeObj.isTestKit);
    }

    if (inventoryTypeObj.colorHex != null) {
      inventoryType.setColorHex(inventoryTypeObj.colorHex);
    }

    if (inventoryTypeObj.practiceInventoryTypes != null) {
      inventoryType.setPracticeInventoryTypes(_.PracticeInventoryType.thawList(inventoryTypeObj.practiceInventoryTypes));
    }

    if (inventoryTypeObj.inUnitLifeDays != null) {
      inventoryType.setInUnitLifeDays(inventoryTypeObj.inUnitLifeDays);
    }

    return inventoryType;
  };

  InventoryType.thawList = function (inventoryTypeObjList) {
    if (inventoryTypeObjList == null) {
      return [];
    }

    var instruments = [];

    for (var i = 0; i < inventoryTypeObjList.length; i++) {
      instruments.push(InventoryType.thaw(inventoryTypeObjList[i]));
    }

    return instruments;
  };

  InventoryType.freeze = function (inventoryType) {
    if (inventoryType == null) {
      return null;
    }

    var inventoryTypeObj = {};

    if (inventoryType.getId() != null) {
      inventoryTypeObj.id = inventoryType.getId();
    }

    if (inventoryType.getName() != null) {
      inventoryTypeObj.name = inventoryType.getName();
    }

    if (inventoryType.getZIndex() != null) {
      inventoryTypeObj.zIndex = inventoryType.getZIndex();
    }

    if (inventoryType.getIsActive() != null) {
      inventoryTypeObj.isActive = inventoryType.getIsActive();
    }

    if (inventoryType.getTestCountPerUnit() != null) {
      inventoryTypeObj.testCountPerUnit = inventoryType.getTestCountPerUnit();
    }

    if (inventoryType.getUnit() != null) {
      inventoryTypeObj.unit = inventoryType.getUnit();
    }

    if (inventoryType.getPluralUnit() != null) {
      inventoryTypeObj.pluralUnit = inventoryType.getPluralUnit();
    }

    if (inventoryType.getImageUrl() != null) {
      inventoryTypeObj.imageUrl = inventoryType.getImageUrl();
    }

    if (inventoryType.getIsCartridge() != null) {
      inventoryTypeObj.isCartridge = inventoryType.getIsCartridge();
    }

    if (inventoryType.getIsRequiredCartridge() != null) {
      inventoryTypeObj.isRequiredCartridge = inventoryType.getIsRequiredCartridge();
    }

    if (inventoryType.getTestTypes() != null) {
      inventoryTypeObj.testTypes = _.TestType.freezeList(inventoryType.getTestTypes());
    }

    if (inventoryType.getCartridgePosition() != null) {
      inventoryTypeObj.cartridgePosition = inventoryType.getCartridgePosition();
    }

    if (inventoryType.getCartridgeRow() != null) {
      inventoryTypeObj.cartridgeRow = inventoryType.getCartridgeRow();
    }

    if (inventoryType.getShelfLifeDays() != null) {
      inventoryTypeObj.shelfLifeDays = inventoryType.getShelfLifeDays();
    }

    if (inventoryType.getDefaultOrderTriggerNumber() != null) {
      inventoryTypeObj.defaultOrderTriggerNumber = inventoryType.getDefaultOrderTriggerNumber();
    }

    if (inventoryType.getDefaultOrderQuantity() != null) {
      inventoryTypeObj.defaultOrderQuantity = inventoryType.getDefaultOrderQuantity();
    }

    if (inventoryType.getMinimumOrderTriggerNumber() != null) {
      inventoryTypeObj.minimumOrderTriggerNumber = inventoryType.getMinimumOrderTriggerNumber();
    }

    if (inventoryType.getDisplayToUser() != null) {
      inventoryTypeObj.displayToUser = inventoryType.getDisplayToUser();
    }

    if (inventoryType.getIsTestKit() != null) {
      inventoryTypeObj.isTestKit = inventoryType.getIsTestKit();
    }

    if (inventoryType.getColorHex() != null) {
      inventoryTypeObj.colorHex = inventoryType.getColorHex();
    }

    if (inventoryType.getPracticeInventoryTypes() != null) {
      inventoryTypeObj.practiceInventoryTypes = _.PracticeInventoryType.freezeList(inventoryType.getPracticeInventoryTypes());
    }

    if (inventoryType.getInUnitLifeDays() != null) {
      inventoryTypeObj.inUnitLifeDays = inventoryType.getInUnitLifeDays();
    }

    return inventoryTypeObj;
  };

  InventoryType.freezeList = function (instruments) {
    if (instruments == null) {
      return [];
    }

    var inventoryTypeObjList = [];

    for (var i = 0; i < instruments.length; i++) {
      inventoryTypeObjList.push(InventoryType.freeze(instruments[i]));
    }

    return inventoryTypeObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  InventoryType.prototype.setId = function (id) {
    this.id = id;
  };

  InventoryType.prototype.setName = function (name) {
    this.name = name;
  };

  InventoryType.prototype.setZIndex = function (zIndex) {
    this.zIndex = zIndex;
  };

  InventoryType.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };

  InventoryType.prototype.setTestCountPerUnit = function (testCountPerUnit) {
    this.testCountPerUnit = testCountPerUnit;
  };

  InventoryType.prototype.setUnit = function (unit) {
    this.unit = unit;
  };

  InventoryType.prototype.setPluralUnit = function (pluralUnit) {
    this.pluralUnit = pluralUnit;
  };

  InventoryType.prototype.setImageUrl = function (imageUrl) {
    this.imageUrl = imageUrl;
  };

  InventoryType.prototype.setIsCartridge = function (isCartridge) {
    this.isCartridge = isCartridge;
  };

  InventoryType.prototype.setIsRequiredCartridge = function (isRequiredCartridge) {
    this.isRequiredCartridge = isRequiredCartridge;
  };

  InventoryType.prototype.setTestTypes = function (testTypes) {
    this.testTypes = testTypes;
  };

  InventoryType.prototype.setStatus = function (status) {
    this.status = status !== null && status !== void 0 ? status : STATUSES.UNKNOWN;
  };

  InventoryType.prototype.setCartridgePosition = function (cartridgePosition) {
    this.cartridgePosition = cartridgePosition;
  };

  InventoryType.prototype.setCartridgeRow = function (cartridgeRow) {
    this.cartridgeRow = cartridgeRow;
  };

  InventoryType.prototype.setShelfLifeDays = function (shelfLifeDays) {
    this.shelfLifeDays = shelfLifeDays;
  };

  InventoryType.prototype.setDefaultOrderTriggerNumber = function (defaultOrderTriggerNumber) {
    this.defaultOrderTriggerNumber = defaultOrderTriggerNumber;
  };

  InventoryType.prototype.setDefaultOrderQuantity = function (defaultOrderQuantity) {
    this.defaultOrderQuantity = defaultOrderQuantity;
  };

  InventoryType.prototype.setMinimumOrderTriggerNumber = function (minimumOrderTriggerNumber) {
    this.minimumOrderTriggerNumber = minimumOrderTriggerNumber;
  };

  InventoryType.prototype.setDisplayToUser = function (displayToUser) {
    this.displayToUser = displayToUser;
  };

  InventoryType.prototype.setIsTestKit = function (isTestKit) {
    this.isTestKit = isTestKit;
  };

  InventoryType.prototype.setColorHex = function (colorHex) {
    this.colorHex = colorHex;
  };

  InventoryType.prototype.setPracticeInventoryTypes = function (practiceInventoryTypes) {
    this.practiceInventoryTypes = practiceInventoryTypes;
  };

  InventoryType.prototype.setInUnitLifeDays = function (inUnitLifeDays) {
    this.inUnitLifeDays = inUnitLifeDays;
  };
  /* -------------------------
    -------------------------
    -------- GETTERS --------
    -------------------------
     ------------------------- */


  InventoryType.prototype.getId = function () {
    return this.id;
  };

  InventoryType.prototype.getName = function () {
    return this.name;
  };

  InventoryType.prototype.getZIndex = function () {
    return this.zIndex;
  };

  InventoryType.prototype.getIsActive = function () {
    return this.isActive;
  };

  InventoryType.prototype.getTestCountPerUnit = function () {
    return this.testCountPerUnit;
  };

  InventoryType.prototype.getUnit = function () {
    return this.unit;
  };

  InventoryType.prototype.getPluralUnit = function () {
    return this.pluralUnit;
  };

  InventoryType.prototype.getImageUrl = function () {
    return this.imageUrl;
  };

  InventoryType.prototype.getIsCartridge = function () {
    return this.isCartridge;
  };

  InventoryType.prototype.getIsRequiredCartridge = function () {
    return this.isRequiredCartridge;
  };

  InventoryType.prototype.getTestTypes = function () {
    return this.testTypes;
  };

  InventoryType.prototype.getStatus = function () {
    var _a;

    return (_a = this.status) !== null && _a !== void 0 ? _a : STATUSES.UNKNOWN;
  };

  InventoryType.prototype.getCartridgePosition = function () {
    return this.cartridgePosition;
  };

  InventoryType.prototype.getCartridgeRow = function () {
    return this.cartridgeRow;
  };

  InventoryType.prototype.getShelfLifeDays = function () {
    return this.shelfLifeDays;
  };

  InventoryType.prototype.getDefaultOrderTriggerNumber = function () {
    return this.defaultOrderTriggerNumber;
  };

  InventoryType.prototype.getDefaultOrderQuantity = function () {
    return this.defaultOrderQuantity;
  };

  InventoryType.prototype.getMinimumOrderTriggerNumber = function () {
    return this.minimumOrderTriggerNumber;
  };

  InventoryType.prototype.getDisplayToUser = function () {
    return this.displayToUser;
  };

  InventoryType.prototype.getIsTestKit = function () {
    return this.isTestKit;
  };

  InventoryType.prototype.getColorHex = function () {
    return this.colorHex;
  };

  InventoryType.prototype.getPracticeInventoryTypes = function () {
    return this.practiceInventoryTypes;
  };

  InventoryType.prototype.getInUnitLifeDays = function () {
    return this.inUnitLifeDays;
  };
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  InventoryType.prototype.isGood = function () {
    return this.status === STATUSES.GOOD;
  };

  InventoryType.prototype.isLow = function () {
    return this.status === STATUSES.LOW;
  };

  InventoryType.prototype.isMissing = function () {
    return this.status === STATUSES.MISSING;
  };

  InventoryType.prototype.isImproperlyInserted = function () {
    return this.status === STATUSES.IMPROPERLY_INSERTED;
  };

  InventoryType.prototype.isUnknown = function () {
    return this.status === STATUSES.UNKNOWN;
  };

  InventoryType.prototype.needsReplacement = function () {
    return this.status === STATUSES.NEEDS_REPLACEMENT;
  };

  InventoryType.prototype.needsRepriming = function () {
    return this.status === STATUSES.NEEDS_PRIMING;
  };

  InventoryType.getListStatus = function (inventoryTypes) {
    if (inventoryTypes == null || inventoryTypes.length === 0) return STATUSES.UNKNOWN; // If any required cartridges are missing

    for (var _i = 0, inventoryTypes_1 = inventoryTypes; _i < inventoryTypes_1.length; _i++) {
      var inventoryType = inventoryTypes_1[_i];
      if (inventoryType.isMissing() && inventoryType.getIsRequiredCartridge()) return STATUSES.MISSING;
    }

    ; // If any required cartridges need replacement

    for (var _a = 0, inventoryTypes_2 = inventoryTypes; _a < inventoryTypes_2.length; _a++) {
      var inventoryType = inventoryTypes_2[_a];
      if (inventoryType.needsReplacement() && inventoryType.getIsRequiredCartridge()) return STATUSES.NEEDS_REPLACEMENT;
    }

    ; // If any cartridges are improperly inserted

    for (var _b = 0, inventoryTypes_3 = inventoryTypes; _b < inventoryTypes_3.length; _b++) {
      var inventoryType = inventoryTypes_3[_b];
      if (inventoryType.isImproperlyInserted()) return STATUSES.IMPROPERLY_INSERTED;
    }

    ; // If any cartridges need priming

    for (var _c = 0, inventoryTypes_4 = inventoryTypes; _c < inventoryTypes_4.length; _c++) {
      var inventoryType = inventoryTypes_4[_c];
      if (inventoryType.needsRepriming()) return STATUSES.NEEDS_PRIMING;
    }

    ; // If any required cartridges are unknown

    for (var _d = 0, inventoryTypes_5 = inventoryTypes; _d < inventoryTypes_5.length; _d++) {
      var inventoryType = inventoryTypes_5[_d];
      if (inventoryType.isUnknown() && inventoryType.getIsRequiredCartridge()) return STATUSES.UNKNOWN;
    }

    ; // If any cartridges are low

    for (var _e = 0, inventoryTypes_6 = inventoryTypes; _e < inventoryTypes_6.length; _e++) {
      var inventoryType = inventoryTypes_6[_e];
      if (inventoryType.isLow()) return STATUSES.LOW;
    }

    ;
    return STATUSES.GOOD;
  };

  InventoryType.updateStatusesFromSensorData = function (inventoryTypes, sensorData, _a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.ignoreCartridgeSensors,
        ignoreCartridgeSensors = _c === void 0 ? false : _c,
        _d = _b.ignoreCartridgeReadySensors,
        ignoreCartridgeReadySensors = _d === void 0 ? false : _d;

    if (inventoryTypes == null || sensorData == null) return;
    inventoryTypes.forEach(function (inventoryType) {
      if (ignoreCartridgeSensors) {
        inventoryType.setStatus(STATUSES.GOOD);
        return;
      } // Obtain sensor values
      // let cartridgePresenceValues = sensorData[`cartridgePresent${inventoryType.getCartridgePosition()}`];
      // let cartridgePresenceValue = cartridgePresenceValues?.length > 0 ? cartridgePresenceValues[cartridgePresenceValues.length - 1] : null;


      var cartridgeFluidLevelValues = sensorData["cartridgeFluidLevel".concat(inventoryType.getCartridgePosition())];
      var cartridgeFluidLevelValue = (cartridgeFluidLevelValues === null || cartridgeFluidLevelValues === void 0 ? void 0 : cartridgeFluidLevelValues.length) > 0 ? cartridgeFluidLevelValues[cartridgeFluidLevelValues.length - 1] : null;
      var cartridgeReadyValues = sensorData["cartridgeReady".concat(inventoryType.getCartridgeRow())]; // improperly inserted, properly inserted

      var cartridgeReadyValue = ignoreCartridgeReadySensors ? true : (cartridgeReadyValues === null || cartridgeReadyValues === void 0 ? void 0 : cartridgeReadyValues.length) > 0 ? cartridgeReadyValues[cartridgeReadyValues.length - 1] : null; // let fluidSensorValues = sensorData[`fluidSensor${inventoryType.getCartridgePosition()}`];
      // let fluidSensorValue = fluidSensorValues?.length > 0 ? fluidSensorValues[fluidSensorValues.length - 1] : null;

      var fluidLineValues = sensorData["fluidLine".concat(inventoryType.getCartridgePosition())];
      var fluidLineValue = (fluidLineValues === null || fluidLineValues === void 0 ? void 0 : fluidLineValues.length) > 0 ? fluidLineValues[fluidLineValues.length - 1] : null; // Fluid line or cartridge fluid level is unknown

      if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_UNKNOWN || cartridgeFluidLevelValue === _.CARTRIDGE_FLUID_LEVELS.CARTRIDGE_FLUID_LEVEL_UNKNOWN) inventoryType.setStatus(STATUSES.UNKNOWN); // Cartridge is missing
      else if (cartridgeFluidLevelValue === _.CARTRIDGE_FLUID_LEVELS.CARTRIDGE_UNINSTALLED) inventoryType.setStatus(STATUSES.MISSING); // Cartridge is present
      else if (cartridgeFluidLevelValue === _.CARTRIDGE_FLUID_LEVELS.CARTRIDGE_FLUID_LEVEL_GOOD) {
        // Cartridge is improperly inserted
        if (cartridgeReadyValue === false) inventoryType.setStatus(STATUSES.IMPROPERLY_INSERTED); // Cartridge is properly inserted
        else if (cartridgeReadyValue === true) {
          // Fluid in line
          if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_PRESENT) inventoryType.setStatus(STATUSES.GOOD); // Fluid not in line
          else if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_NOT_PRESENT) inventoryType.setStatus(STATUSES.GOOD); // TEMPORARILY CHANGED IN ORDER TO AVOID REPRIMES DUE TO BUBBLES IN LINE
          // Fluid line is disconnected... for now, unknown
          else if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_DISCONNECTED) inventoryType.setStatus(STATUSES.UNKNOWN);else inventoryType.setStatus(STATUSES.UNKNOWN);
        } else inventoryType.setStatus(STATUSES.UNKNOWN);
      } // Cartridge is low
      else if (cartridgeFluidLevelValue === _.CARTRIDGE_FLUID_LEVELS.CARTRIDGE_FLUID_LEVEL_LOW) {
        // Cartridge is improperly inserted
        if (cartridgeReadyValue === false) inventoryType.setStatus(STATUSES.IMPROPERLY_INSERTED); // Cartridge is properly inserted
        else if (cartridgeReadyValue === true) {
          // Fluid in line
          if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_PRESENT) inventoryType.setStatus(STATUSES.LOW); // Fluid not in line
          else if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_NOT_PRESENT) inventoryType.setStatus(STATUSES.NEEDS_REPLACEMENT); // Fluid line is disconnected... for now, unknown
          else if (fluidLineValue === _.FLUID_LINE_STATES.FLUID_DISCONNECTED) inventoryType.setStatus(STATUSES.UNKNOWN);else inventoryType.setStatus(STATUSES.UNKNOWN);
        } else inventoryType.setStatus(STATUSES.UNKNOWN);
      } else inventoryType.setStatus(STATUSES.UNKNOWN);
    });
  };

  return InventoryType;
}();

var _default = InventoryType;
exports.default = _default;